import { useCallback } from "react";
import { TilesV2 } from "@components";
import classNames from "classnames";

import type { ProductOptionPickerProps } from "..";

import Label from "./Label";
import renderMethodsV2 from "./renderMethodsV2";

export type OptionPickerProps = Omit<
  ProductOptionPickerProps,
  "groups" | "useActiveGroupTitle" | "modal"
>;

const TILE_CHARACTER_LIMIT = 10;

export default function OptionPicker({
  className,
  gridColumns,
  isNested: useNestedLayout,
  reflowForMobile,
  label,
  name,
  onChange,
  selectedValue,
  type = "tile",
  pageSize,
  values,
  inModal,
}: OptionPickerProps) {
  const handleChange = useCallback(
    (value: string) => {
      onChange(name, value);
    },
    [name, onChange]
  );

  const dataLabel = `${name.toLowerCase()}-option-picker`;

  return (
    <div
      className={classNames(
        "flex items-center w-full",
        {
          "-mx-6 lg:mx-0": type.includes("graphic"),
        },
        className
      )}
      data-event-category={dataLabel}
    >
      <TilesV2
        items={values}
        label={label ? <Label>{label}</Label> : undefined}
        onChange={handleChange}
        renderOption={renderMethodsV2[type]}
        value={selectedValue}
        useGrid={type !== "swatch" && !useNestedLayout}
        useGraphics={type.includes("graphic")}
        reflowForMobile={reflowForMobile}
        gridColumns={gridColumns}
        pageSize={pageSize}
        stretchAndWrapItems={
          ["tile", "group"].includes(type) &&
          (inModal || values.some((v) => v.value.length > TILE_CHARACTER_LIMIT))
        }
        className={classNames({
          "w-full justify-start": useNestedLayout,
        })}
      />
    </div>
  );
}
